module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/photo-08b1d.png";